// extracted by mini-css-extract-plugin
module.exports = {"loading_background":"loading_loading_background__2AWa3","svg":"loading_svg__1wQx_"};